<template>
  <div class="leads-assign-dialog">
    <!--<div class="leads-assign-selected">
        已选中数据<span>{{memberNumber}}</span>
    </div>-->
    <div class="leads-assign-to-staff">
       <!-- <div class="leads-assign-to-staff-radio">
            <el-input
                    size="medium"
                    placeholder="请输入内容"
                    suffix-icon="el-icon-search"
                    v-model="selectStaff">
            </el-input>
           &lt;!&ndash; <el-radio v-model="leadsAssignRadio" label="1" @change="radioChange()">按部门</el-radio>
            <el-radio v-model="leadsAssignRadio" label="2" @change="radioChange()">按员工</el-radio>&ndash;&gt;
        </div>-->
       <!-- <div class="leads-assign-to-staff-type" v-if="leadsAssignRadio =='1' ">
            <member-tree
                    :memberListShow="memberListShow"
                    ref="memberTree"
                    :assignType="department"
            ></member-tree>
        </div>-->
        <div class="leads-assign-to-staff-type">
            <member-tree
                    :member-list-show="memberList2"
                    ref="memberTree"
                    :assignType="staff"
            ></member-tree>

        </div>
    </div>
</div>
</template>

<script>
import MemberTree from "../../../components/memberTree";
export default {
    components: {MemberTree},
    data(){
        return{
            options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
            }],
            leadsAssignDialogVisible: false,
            leadsAssignRadio: '1',
            leadsAssignProps: {
                children: "children",
                label: "name"
            },
            memberListShow:[],
            defaultExpandAll:true,
            treeExpandData:[],
            defaultExpandAll2:true,
            leadsAssignProps2: {
                children: "children",
                label: "name"
            },
            memberList2:[],
            treeExpandData2:[],
            memberNumber:0,
            selectMember:[],
            department:'department',
            staff:'staff',
            selectStaff:''
        }
    },
    methods:{
        radioChange(){
            console.log(this.leadsAssignRadio,'+++++++++');
        },
        //获取员工信息
        getMember(){
            let url='/scrm-api/we-work/member'
            this.$http.get(url).then(res=>{
                console.log('员工信息',res)
                if (res.status===200){
                    this.memberList=JSON.parse(JSON.stringify(res.data))
                    this.memberList2=JSON.parse(JSON.stringify(res.data))

                    this.selectNoIsmember(this.memberList)
                    /*this.selectIsmember(this.memberList2)*/
                    console.log('memberList',this.memberList2)
                    this.memberListShow= this.memberList

                }
            })
        },

        checkBUmen(value){
            console.log(value)
            if (value!==undefined&&value.length > 0){
                for (let i=value.length-1;i>=0;i--){
                    console.log(value[i].children)
                    if (value[i]!==undefined&&(value[i].children===null||value[i].children.length===0)){
                        value.splice(i,1)
                        this.checkBUmen(value[i])
                    }
                    else {
                        this.checkBUmen(value[i].children)
                    }
                }
            }
        },
        selectNoIsmember(value){
            if (value.length > 0){
                for (let i=value.length-1;i>=0;i--){

                    if (value[i].isMember){
                        value.splice(i,1)
                        if (value[i]!==undefined&&value[i].children!==null){
                            this.selectNoIsmember(value[i].children)
                        }
                    }
                    else {
                        if (value[i].children!==null){
                            this.selectNoIsmember(value[i].children)
                        }
                    }
                }
            }

        },
        selectIsmember(value){
            if (value.length > 0){
                for (let i=value.length-1;i>=0;i--){

                    if (!value[i].isMember){
                        value.splice(i,1)
                        if (value[i]!==undefined&&value[i].children!==null){
                            this.selectIsmember(value[i].children)
                        }
                    }
                    else {
                        if (value[i].children!==null){
                            this.selectIsmember(value[i].children)
                        }
                    }
                }
            }

        },
        changeCheckedOrg(node,data){
            if (data.checked) {
                this.selectMember.unshift(data);
            } else {
                this.selectMember.forEach((cell, cellIndex) => {
                    if (cell.id == data.id) {
                        this.selectMember.splice(cellIndex, 1);
                    }
                });
            }
            this.selectMember = [...this.selectMember];
            this.memberNumber=this.selectMember.length
        },
    },
    mounted() {
        this.getMember()
    }
}
</script>

<style lang="less">
.leads-assign-dialog{
  padding:0 20px;
  .leads-assign-selected{
    span{
      color: #409eff;
        margin-left: 4px;
    }
  }
  .leads-assign-to-staff{
    .leads-assign-to-staff-radio{
      margin: 20px 0px;
    }
  }
    .member-tree{
        height: calc(100vh - 450px);
        overflow-y: scroll;
        overflow-x: hidden;
        .custom-tree-node{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            padding-right: 8px;
        }

    }
}
</style>